import { GameVars } from "../../GameVars";
import { TrophyState } from "./TrophyState";
import { AudioManager } from "../../AudioManager";

export class IntroReporter extends Phaser.Group {

    private static WELLCOME_STATE = 0;
    private static SHOWING_TROPHIES_STATE = 1;
    private static GOODBYE_STATE = 2;
    private static END_STATE = 3;

    private static MSG_1_PX = 135;
    private static MSG_1_PY = 190;
    private static MSG_2_PX = 120;
    private static MSG_2_PY = 170;
    private static MSG_3_PX = 115;
    private static MSG_3_PY = 185;

    private nextButton: Phaser.Button;
    private msg: Phaser.Text;
    private balloon: Phaser.Image;
    private reporter: Phaser.Sprite;
    private mole: Phaser.Sprite;
    private rndGenerator: Phaser.RandomDataGenerator;

    private moleBlinkTimeEvent: Phaser.TimerEvent;
    private reporterTalkTimeEvent: Phaser.TimerEvent;

    private reporterState: number;

    constructor(game: Phaser.Game) {

        super(game, null, "intro-reporter", false);

        // el letrero de la TV
        this.create(590, 70, "texture_atlas_3", "chinkosports");

        this.addBalloon();
        this.addReporter();
        this.addMole();
        this.addNextButton();

        this.reporterState = IntroReporter.WELLCOME_STATE;
    }

    private addNextButton(): void {

        this.nextButton = new Phaser.Button(this.game, 676, 670, "texture_atlas_5", this.onClickNext, this);
        this.nextButton.setFrames("boton_next_on", "boton_next_off", "boton_next_on");
        this.nextButton.anchor.set(.5);
        this.add(this.nextButton);

        let pulseTween: Phaser.Tween = this.game.add.tween(this.nextButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();
    }

    private addBalloon(): void {

        this.balloon = new Phaser.Image(this.game, 52, 100, "texture_atlas_3", "intro_bocadillo");
        this.add(this.balloon);

        this.msg = new Phaser.Text(this.game, IntroReporter.MSG_1_PX, IntroReporter.MSG_1_PY,
            GameVars.gameText.TUTORIAL_MSG_1,
            { font: GameVars.gameText.TUTORIAL_FONT_SIZE + "px dnk", fill: "#000000" });

        this.add(this.msg);
    }

    private addReporter(): void {

        this.rndGenerator = new Phaser.RandomDataGenerator([1, 2, 3]);

        let atrezzoBall = new Phaser.Image(this.game, 370, 660, "texture_atlas_2", "balon_extra");
        atrezzoBall.scale.set(1.5);
        this.add(atrezzoBall);

        let reporterName = new Phaser.Image(this.game, 335, 780, "texture_atlas_3", "reporter_name");
        reporterName.anchor.set(.5);
        this.add(reporterName);

        this.reporter = new Phaser.Sprite(this.game, 180, 470, "texture_atlas_3", "intro_speaker_0001");
        this.add(this.reporter);

        this.reporter.animations.add("talk", Phaser.Animation.generateFrameNames("intro_speaker_", 1, 3, "", 4));
        this.reporter.animations.add("talk_reversed", Phaser.Animation.generateFrameNames("intro_speaker_", 3, 1, "", 4));
        this.reporter.animations.play("talk", this.rndGenerator.between(8, 16), false);

        this.reporterTalkTimeEvent = this.game.time.events.add(250 + Math.random() * 350, this.talkAgain, this);
    }

    private talkAgain(): void {

        if (this.reporterState === IntroReporter.SHOWING_TROPHIES_STATE) {
            return;
        }

        if (Math.random() > .5) {
            this.reporter.animations.play("talk", this.rndGenerator.between(14, 20), false);
        } else {
            this.reporter.animations.play("talk_reversed", this.rndGenerator.between(8, 16), false);
        }

        this.reporterTalkTimeEvent = this.game.time.events.add(250 + Math.random() * 350, this.talkAgain, this);
    }

    private addMole(): void {

        this.mole = new Phaser.Sprite(this.game, 500, 675, "texture_atlas_3", "intro_topo_1");
        this.add(this.mole);

        this.moleBlinkTimeEvent = this.game.time.events.add(1500 + Math.random() * 1000, this.moleBlink, this);
    }

    private moleBlink(): void {

        this.mole.frameName = "intro_topo_2";
        this.moleBlinkTimeEvent = this.game.time.events.add(250, this.moleIdle, this);
    }

    private moleIdle(): void {

        this.mole.frameName = "intro_topo_1";
        this.moleBlinkTimeEvent = this.game.time.events.add(1500 + Math.random() * 1000, this.moleBlink, this);
    }

    private onClickNext(): void {

        if (this.reporterState === IntroReporter.WELLCOME_STATE) {

            this.msg.text = GameVars.gameText.TUTORIAL_MSG_2;
            this.msg.x = IntroReporter.MSG_2_PX;
            this.msg.y = IntroReporter.MSG_2_PY;
            this.reporterState = IntroReporter.SHOWING_TROPHIES_STATE;
            this.game.time.events.remove(this.reporterTalkTimeEvent);

            // parece que el reporterTalkTimeEvent se acciona a pesar de haberlo cancelado
            this.game.time.events.add(600, function (): void {
                this.reporter.frameName = "intro_speaker_0004";
                TrophyState.currentInstance.removeIntroTrophies();
            }, this);

            this.nextButton.visible = false;
            this.game.time.events.add(2000, function (): void {
                this.nextButton.visible = true;
            }, this);

        } else if (this.reporterState === IntroReporter.SHOWING_TROPHIES_STATE) {
            this.msg.text = GameVars.gameText.TUTORIAL_MSG_3;
            this.msg.x = IntroReporter.MSG_3_PX;
            this.msg.y = IntroReporter.MSG_3_PY;
            this.reporterState = IntroReporter.GOODBYE_STATE;
            this.game.time.events.add(250 + Math.random() * 350, this.talkAgain, this);

            this.nextButton.visible = false;
            this.game.time.events.add(2000, function (): void {
                this.nextButton.visible = true;
            }, this);

        } else if (this.reporterState === IntroReporter.GOODBYE_STATE) {

            this.reporterState = IntroReporter.END_STATE;
            this.nextButton.clearFrames();

            // cargarnos los 2 eventos
            this.game.time.events.remove(this.moleBlinkTimeEvent);
            this.game.time.events.remove(this.reporterTalkTimeEvent);

            this.game.add.tween(this).to({ alpha: 0 }, 1000, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function (): void {
                    TrophyState.currentInstance.onIntroSeen();
                    this.destroy(true);
                }, this);
        }

        AudioManager.getInstance().playEffect("play");
    }
}
